// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bhr_h bhr_kh bhr_we bhr_su bhr_vt bhr_sw bhr_sn"};